import { CHAT_SOCKET_PATH } from './chatSocketPath';

export function getChatIoOptions(token, extra = {}) {
  return {
    path: CHAT_SOCKET_PATH,
    auth: { token },
    query: { token },
    transports: ['polling', 'websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 15000,
    timeout: 20000,
    autoConnect: true,
    ...extra,
  };
}
